import React, { Component } from 'react';
import './Footer.scss';

export class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="footer-col col-md-4">
                <h5>Location</h5>
                <p>Ukraine<br />Pavlograd 51413</p>
              </div>
              <div className="footer-col col-md-4">
                <h5>Contact us</h5>
                <ul className="footer-share">
                  <li><a href="mailto:mail@ferumsoft.epizy.com">mail@ferumsoft.epizy.com</a></li>
                </ul>
              </div>
              <div className="footer-col col-md-4">
                <h5>Plans</h5>
                <p>Contact us to get more info about our service</p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="col-md-12">
              <p>Copyright © FerumSoft. All Rights Reserved<br />Made with <i className="fa fa-heart pulse"></i> by <a href="/">FerumSoft</a></p>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
